import { RefreshCw, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { runningEntry, watchDeploymentUpdates } from '../../lib/deploymentUpdate';

export function DeploymentUpdateNotice() {
  const [available, setAvailable] = useState<string>();
  useEffect(() => {
    const entry = runningEntry(document);
    if (entry) return watchDeploymentUpdates({ entry, onUpdate: setAvailable });
  }, []);
  if (!available) return null;
  return <aside aria-label="网站更新" className="toolbox-update-notice" role="status">
    <RefreshCw aria-hidden="true" size={16} />
    <p>网站已更新。刷新会清空未保存内容，请先完成当前任务。</p>
    <button onClick={() => window.location.reload()} type="button">刷新更新</button>
    <button aria-label="暂不更新" onClick={() => setAvailable(undefined)} type="button"><X size={16} /></button>
  </aside>;
}
